import { Tooltip } from 'antd';
import { PricingInput, PricingInputProps } from '../Pricing.Common';

export interface PricingSettingsPercentageInputProps
  extends Pick<
    PricingInputProps,
    | 'disabled'
    | 'initialValue'
    | 'resetOnInitialValueChange'
    | 'onSubmit'
    | 'placeholder'
  > {
  tooltipText?: React.ReactNode;
  showTooltip?: boolean;
}

export function PricingSettingsPercentageInput(
  props: PricingSettingsPercentageInputProps,
) {
  const { tooltipText, showTooltip } = props;
  const input = (
    <PricingInput prefix="%" min={0} max={10000} precision={6} {...props} />
  );

  if (showTooltip && tooltipText != null) {
    return <Tooltip title={tooltipText}>{input}</Tooltip>;
  }

  return input;
}
